export default __webpack_public_path__ + "static/media/gif-logo-mini-transparent.569ec9c9.gif";